module.exports = __webpack_public_path__ + "img/Company_users_active.d07719de.svg";